import { render, staticRenderFns } from "./BookingEvents.vue?vue&type=template&id=55514984&scoped=true&"
import script from "./BookingEvents.vue?vue&type=script&lang=ts&"
export * from "./BookingEvents.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./BookingEvents.vue?vue&type=style&index=1&id=55514984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55514984",
  null
  
)

export default component.exports